// import { Button } from "@mantine/core";
import './Button.css';
const EBSButton = ({ children, onClick }: { children: React.ReactNode; onClick: () => void }) => {
    return (
        // <Button
        //     styles={(theme) => ({
        //         root: {
        //             margin: "0px 5px",
        //             backgroundColor: '#2465EA20',
        //             borderRadius: '10px',
        //             transition: "0.25s ease-in-out",

        //             '&:hover': {
        //                 backgroundColor: '#2465EA30',
        //             },
        //         },
        //     })}
        // >
        //     <img className=" my-auto" src={`/assets/svg/${icon}.svg`} />

        // </Button>
        <div onClick={onClick} className="ebs-button px-3">
            {children}
        </div>
    );
}

export default EBSButton;